import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/img/icons/info-grey.svg'
import _imports_2 from '@/assets/img/icons/back.svg'
import _imports_3 from '@/assets/img/icons/next.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/3 flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-1/3 mb-3"
  })
], -1)
const _hoisted_2 = { class: "w-2/3 mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl text-blue-900 mb-3 font-semibold text-center" }, " Pilih Template Email ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 border border-gray-200 rounded p-4 flex gap-2 w-1/2 mx-auto items-start mb-8" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "mt-1"
  }),
  /*#__PURE__*/_createTextVNode(" Anda bisa mengatur pesan yang akan dikirimkan ke peserta asesmen ")
], -1)
const _hoisted_5 = { class: "relative h-16" }
const _hoisted_6 = { class: "bg-white border-t p-2 left-0 flex gap-3 justify-between fixed bottom-0 w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-3 h-3"
}, null, -1)
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_email_template_list = _resolveComponent("email-template-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_email_template_list, {
          data: _ctx.templates,
          selectedTemplate: _ctx.selectedTemplate,
          onSetSelectedTemplate: _ctx.setSelectedTemplate
        }, null, 8, ["data", "selectedTemplate", "onSetSelectedTemplate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "px-4 py-2 bg-transparent border-1 border-gray-300 rounded text-blue-900 text-sm leading-6 font-semibold flex items-center gap-3"
        }, [
          _hoisted_7,
          _createTextVNode(" Kembali ")
        ]),
        _createElementVNode("button", {
          disabled: !_ctx.canSubmit,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args))),
          class: _normalizeClass(["px-4 py-2 rounded text-black leading-6 text-sm font-semibold flex items-center gap-3", 
          _ctx.canSubmit ? 'bg-yellow-400 opacity-1' : 'bg-gray-400 opacity-30'
        ])
        }, [
          _createTextVNode(" Lanjutkan "),
          _hoisted_9
        ], 10, _hoisted_8)
      ])
    ])
  ], 64))
}